import React from 'react';
import { Grid } from '@tmap/mmm-style-guide/src/Grid';
import { Typography } from '@tmap/mmm-style-guide/src/Typography';
import { Field } from '@tmap/mmm-style-guide/src/final-form/react';
import configToProps from './configToProps';
import Question from './question';
import getFieldConfigByPath from '../../lib/commonApp/getFieldConfigByPath';

function ContactInfoFormBody(props) {
  const {
    incentive,
    fieldConfigs = [],
  } = props;
  const firstName = getFieldConfigByPath(fieldConfigs, 'user_profile.firstName');
  const lastName = getFieldConfigByPath(fieldConfigs, 'user_profile.lastName');
  const dob = getFieldConfigByPath(fieldConfigs, 'user_profile.personalInfo.dob');
  const phoneNumber = getFieldConfigByPath(fieldConfigs, 'user_profile.phone');
  const allowPhoneContact = getFieldConfigByPath(fieldConfigs, 'user_profile.notifPrefs.Mover.text');
  const address = getFieldConfigByPath(fieldConfigs, 'user_profile.personalInfo.address');
  const address2 = getFieldConfigByPath(fieldConfigs, 'user_profile.personalInfo.address2');
  const city = getFieldConfigByPath(fieldConfigs, 'user_profile.personalInfo.city');
  const state = getFieldConfigByPath(fieldConfigs, 'user_profile.personalInfo.state');
  const postalCode = getFieldConfigByPath(fieldConfigs, 'user_profile.personalInfo.postalCode');
  return (
    <Grid container spacing={{ xs: 4, md: 2 }} alignItems='start'>
      <Grid item xs={12}>
        <Typography variant='body1' gutterBottom>Contact Information</Typography>
      </Grid>
      {firstName && (
        <Grid item xs={12} sm={6}>
          <Field {...configToProps(firstName, { config: firstName, incentive })} />
        </Grid>
      )}
      {lastName && (
        <Grid item xs={12} sm={6}>
          <Field {...configToProps(lastName, { config: lastName, incentive })} />
        </Grid>
      )}
      {dob && (
        <Grid item xs={12} sm={6}>
          <Field {...configToProps(dob, { config: dob, incentive })} />
        </Grid>
      )}
      {dob && (
        <Grid item xs={12} sm={6}>
          <Field {...configToProps(phoneNumber, { config: phoneNumber, incentive })} />
        </Grid>
      )}
      <Question field={allowPhoneContact} data={{ incentive }} titleSpacing='medium' />
      {address && (
        <Grid item xs={12} sm={7}>
          <Field {...configToProps(address, { config: address, incentive })} />
        </Grid>
      )}
      {address2 && (
        <Grid item xs={12} sm={5}>
          <Field {...configToProps(address2, { config: address2, incentive })} />
        </Grid>
      )}
      {city && (
        <Grid item xs={12} sm={4}>
          <Field {...configToProps(city, { config: city, incentive })} />
        </Grid>
      )}
      {state && (
        <Grid item xs={12} sm={4}>
          <Field {...configToProps(state, { config: state, incentive })}>
            <option value=''></option>
            {state.options.map((op) => (
              <option value={op.value} key={op.value}>{op.label}</option>
            ))}
          </Field>
        </Grid>
      )}
      {postalCode && (
        <Grid item xs={12} sm={4}>
          <Field {...configToProps(postalCode, { config: postalCode, incentive })} />
        </Grid>
      )}
    </Grid>
  );
}

export default ContactInfoFormBody;
